import { defineStore } from 'pinia';
import { readonly, ref } from 'vue';

export const THEMES = ['SILog', 'TiYard'] as const;
export type Theme = (typeof THEMES)[number];

const STORAGE_KEY = 'app-theme';
const DEFAULT_THEME: Theme = 'SILog';

function isTheme(value: unknown): value is Theme {
  return THEMES.includes(value as Theme);
}

function loadTheme(): Theme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (isTheme(stored)) return stored;
  } catch {
    // localStorage unavailable (private mode, blocked, etc.)
  }
  return DEFAULT_THEME;
}

function saveTheme(theme: Theme) {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // ignore
  }
}

export const useThemeStore = defineStore('theme', () => {
  const currentTheme = ref<Theme>(loadTheme());

  function setTheme(theme: Theme) {
    currentTheme.value = theme;
    saveTheme(theme);
  }

  return { currentTheme: readonly(currentTheme), setTheme };
});
